import React from "react";
import { Phone, Mail, MapPin, ArrowUp } from "lucide-react";
import { profile, navLinks } from "../data/mock";

const Footer = () => {
  return (
    <footer className="bg-[#0B1E3F] text-[#F8F5EE] pt-20 pb-8 relative overflow-hidden">
      <div className="absolute inset-0 grain" />
      <div className="max-w-7xl mx-auto container-px relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pb-14 border-b border-[#F8F5EE]/15">
          <div className="lg:col-span-5">
            <img
              src="/images/dr-hardik-logo-light.png"
              alt={profile.name}
              className="h-20 w-auto object-contain object-left"
            />
            <div className="mt-4 text-[11px] tracking-[0.25em] uppercase text-[#C9A961]">{profile.tagline}</div>
            <p className="mt-5 text-[14px] text-[#F8F5EE]/65 max-w-md leading-relaxed">
              {profile.positioning}
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[11px] tracking-[0.25em] uppercase text-[#C9A961] mb-5">Navigate</div>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-[14px] text-[#F8F5EE]/75 hover:text-[#C9A961] transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[11px] tracking-[0.25em] uppercase text-[#C9A961] mb-5">Reach Us</div>
            <ul className="space-y-4 text-[14px] text-[#F8F5EE]/75">
              <li className="flex items-center gap-3"><Phone size={14} className="text-[#C9A961]" /> {profile.contact.phone}</li>
              <li className="flex items-center gap-3"><Mail size={14} className="text-[#C9A961]" /> {profile.contact.email}</li>
              <li className="flex items-start gap-3"><MapPin size={14} className="text-[#C9A961] mt-1 flex-shrink-0" /> {profile.contact.address}</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8">
          <p className="text-[12px] text-[#F8F5EE]/55">
            © {new Date().getFullYear()} Dr. Hardik Barot · DianaMik Hospital Management Consultancy. All rights reserved.
          </p>
          <a href="#top" className="inline-flex items-center gap-2 text-[12px] tracking-[0.2em] uppercase text-[#F8F5EE]/70 hover:text-[#C9A961] transition-colors">
            Back to top <ArrowUp size={14} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
